import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class DocumentPassportMeta extends BaseEntityModel {
  parentId?: number;
  passportNumber?: string;

  constructor(model: Partial<DocumentPassportMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.passportNumber = model.passportNumber;
  }
}
